<template>
  <section class="cn-about-header-section">
    <div class="container">
      <div class="cn-about-header-section__text">
        <div class="cn-about-header-section__text-left">
          <h1 class="cn-about-header-section__title">
            {{ data.title }}
          </h1>
        </div>
        <div class="cn-about-header-section__text-right">
          <ul class="cn-about-header-section__list">
            <li
              v-for="(item, i) in data.list"
              :key="i"
              class="cn-about-header-section__list-item"
            >
              <UiParallelogram color="aqua" />
              <span class="cn-about-header-section__list-item-description">
                {{ item }}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import UiParallelogram from '@/components/ui/UiParallelogram';

interface Props {
  data: {
    title?: string;
    list?: string[];
  };
}
defineProps<Props>();
</script>

<style lang="scss">
.cn-about-header-section {
  --ab-canyon-about-header-section-title-color-text: var(
    --ab-canyon-color-primary
  );
  --ab-canyon-about-header-section-list-item-description-color-text: var(
    --ab-canyon-color-neutral-dark
  );

  padding-top: var(--size-3xl);
  padding-bottom: var(--size-3xl);
  &__text {
    column-gap: var(--size-3xl);
    justify-content: space-between;
    flex-direction: column;
    display: flex;
    @media (min-width: 656px) {
      flex-direction: row;
    }
  }
  &__text-left {
    max-width: 700px;
  }
  &__title {
    color: var(--ab-canyon-about-header-section-title-color-text);
    text-transform: uppercase;
    font-weight: 700;
    font-size: 1.5rem;
    line-height: 1.25;
    @media (min-width: 656px) {
      font-size: 1.875rem;
      line-height: 2.25rem;
    }
    @media (min-width: 992px) {
      font-size: 2.25rem;
      line-height: 2.5rem;
    }
    @media (min-width: 1280px) {
      line-height: 1.25;
    }
    @media (min-width: 1656px) {
      font-size: 3rem;
      line-height: 1;
    }
  }
  &__text-right {
    max-width: 400px;
    margin-top: var(--size-xl);
    @media (min-width: 656px) {
      margin-top: 0px;
    }
  }
  &__list {
    > :not([hidden]) {
      ~ :not([hidden]) {
        margin-top: var(--size-base);
        @media (min-width: 656px) {
          margin-top: calc(4 * var(--size-base));
        }
      }
    }
  }
  &__list-item {
    column-gap: var(--size-base);
    display: flex;

    .cn-parallelogram {
      width: var(--size-base);
      height: var(--size-3xl);
    }
  }
  &__list-item-description {
    color: var(
      --ab-canyon-about-header-section-list-item-description-color-text
    );
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
</style>
